import noop from "lodash/noop";

import { IconButton, Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { SuggestedTopicPill } from "app/pages/activation/components/Shared/SuggestedTopicPill/SuggestedTopicPill";
import { StyledTopicGroup, StyledTopicName } from "app/pages/activation/components/Topics/Topic/styles";

import { CHAR_REASONING_LIMIT_SIZE } from "../constants";

import { itemKeys } from "./automationKeys";
import * as SC from "./styles";
import { COMMON_ADD_TEXT, COMMON_SELECTED_TEXT } from "./texts";
import type { WebsiteListItemSchema } from "./types";

export const WebsiteListItem = ({
    suggestedWebsite,
    isSelected,
    isDisabled,
    suggestionReason,
    isAISuggestion,
    isMaxSelected,
    onClick,
}: WebsiteListItemSchema) => (
    <SC.ItemContainer
        key={suggestedWebsite.name}
        onClick={() => (!isMaxSelected || isSelected ? onClick(suggestedWebsite) : noop)}
        isDisabled={isDisabled}
        data-automation={itemKeys.container}
    >
        <SC.IconsContainer>
            <img
                src={suggestedWebsite.image}
                width="16px"
                height="16px"
                alt=""
            />
        </SC.IconsContainer>

        <div>
            <StyledTopicGroup>
                <StyledTopicName data-automation={itemKeys.name}>{suggestedWebsite.name}</StyledTopicName>

                {isAISuggestion ? <SuggestedTopicPill /> : null}
            </StyledTopicGroup>

            {suggestionReason ? (
                <Tooltip
                    enabled={suggestionReason.length > CHAR_REASONING_LIMIT_SIZE}
                    content={suggestionReason}
                >
                    <SC.AISuggestionReasonText data-automation={itemKeys.suggestedReason}>
                        {suggestionReason}
                    </SC.AISuggestionReasonText>
                </Tooltip>
            ) : null}
        </div>

        <SC.ButtonContainer>
            <IconButton
                type="flat"
                iconName={isSelected ? "checked" : "add"}
                iconSize="xs"
                isDisabled={isMaxSelected ? !isSelected : null}
                dataAutomation={itemKeys.btn}
            >
                {isSelected ? translate(COMMON_SELECTED_TEXT) : translate(COMMON_ADD_TEXT)}
            </IconButton>
        </SC.ButtonContainer>
    </SC.ItemContainer>
);
